var React = require('react');

function CubeMd (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"cube-md"),React.createElement("path",{"d":"M8.78.24,28.9,0l6,19.18-20.12.24Z","fill":"#82d2f9","key":1}),React.createElement("path",{"d":"M34.85,19.18,25.72,31.83l-20.13.24,9.14-12.65Z","fill":"#3d6aa0","key":2}),React.createElement("path",{"d":"M14.73,19.42,5.94,31.71,0,12.53,8.78.24Z","fill":"#61aad6","key":3})]);
}

CubeMd.defaultProps = {"viewBox":"0 0 34.85 32.07"};

module.exports = CubeMd;

CubeMd.default = CubeMd;
